import React from 'react';

const ComingSoon = () => (
	<div>
		<div className="content-header">
			<h1>Coming Soon...</h1>
		</div>
		<section className="content mtm10" data-testid="soon-content">
			<div className="row">
				<div className="col-xs-12">This content is under development and will be available soon.</div>
			</div>
		</section>
	</div>
);

export default ComingSoon;
